import React from "react";
import Container from 'react-bootstrap/Container';
import { Link } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';


const ResearchSupport = () =>{
  
  return (
    <div className="ResearchToolCollections">
      <section className="inner-banner banner-align">
        <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/img/innerbanner/researchsupport.jpg"} alt="Research Support"/>
      </section>
     
      <section  className="research-box-area">
           <Container>
              <div className='information-content'>
                <h2>Research Support</h2>
                <p>Our goal is to provide you with the resources and assistance you need to excel in your research endeavors. Whether you're seeking individual guidance, requesting specific materials, or looking to enhance your skills through workshops, we're here to support your academic journey.</p>
              </div>
              <Row className="ParentBorderBox">
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <img src={process.env.PUBLIC_URL + "/assets/img/researchtool/icons/book-sessions.svg"} alt="" />
        <h5>Book ‘One on one’ session</h5>
        <p>We offer one-on-one consultation for personalized research assistance tailored to your specific needs. Schedule a meeting with one of our experienced librarians to get help with finding resources, developing research strategies, or navigating databases. This dedicated time ensures you receive the focused support you need to advance your research.</p>
        <Link as={Link} to="/book-session" className='btn-dfault'>
        See Details
        </Link>
    </div>
    </Col>
    {/* <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <img src={process.env.PUBLIC_URL + "/assets/img/researchtool/icons/InterLibraryLoan.svg"} alt="" />
        <h5>Article Request Form/Inter Library Loan</h5>
        <p>Can't find the article or book you need in our collection? Use our Article Request Form or Inter Library Loan service to access materials from other libraries. Simply fill out the request form with the details of the item you're looking for, and we'll do our best to obtain it for you. This service broadens your access to essential resources, ensuring you have the materials necessary for comprehensive research. </p>
        <Link as={Link} to="/book-session" className='btn-dfault'>
        See Details
        </Link>
    </div>
    </Col> */}
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <img src={process.env.PUBLIC_URL + "/assets/img/researchtool/icons/Workshops.svg"} alt="" />
        <h5>Upcoming Trainings/Workshops</h5>
        <p>Stay informed about our upcoming trainings and workshops designed to enhance your research and digital skills. Our sessions cover a range of topics, from advanced database searching techniques to effective citation management as well as bite-sized workshops and maker sessions. Join our workshops to stay up-to-date with the latest research tools and methods, and to connect with fellow researchers in our academic community.</p>
        <Link as={Link} to="/event-calendar" className='btn-dfault'>
        See Details
        </Link>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <img src={process.env.PUBLIC_URL + "/assets/img/researchtool/icons/SelfLearner.svg"} alt="" />
        <h5>Self-Learning Resources</h5>
        <p>We have put together a list of resources that you can use to expand your knowledge and skills related to academic research, citation, and referencing.</p>
        <Link as={Link} to="/self-learning-resources" className='btn-dfault'>
        See Details
        </Link>
    </div>
    </Col>
</Row>
           </Container>
      </section>
     
    </div>
  );
}
export default ResearchSupport;